import { importProvidersFrom, ApplicationConfig, provideAppInitializer, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RdsAlertModule, RdsIconComponent, RdsNativeDateModule, RdsToastModule } from "@rds/angular-components";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthInterceptor } from './services/auth-interceptor.service';
import { ApiUrlInterceptor } from './services/api-url.interceptor';
import { FeatureService } from './services/feature.service';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      RdsToastModule,
      RdsAlertModule,
      RdsNativeDateModule,
      AppRoutingModule
    ),
    { provide: HTTP_INTERCEPTORS, useClass: ApiUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    // Resolve the backend's feature set before the first route renders.
    provideAppInitializer(() => inject(FeatureService).load())
  ]
};

// We're using the standalone components approach now, so no need for NgModule
